export default __webpack_public_path__ + "static/media/star3.05137ece.mp3";